import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FaPhone, FaPhoneSlash, FaBackspace } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CustomPhoneInput from "./PhoneInput";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomPhoneInputd from "./CustomPhoneInputd";
import { useContext } from "react";
import { ConfigContext } from "../../context/ConfigContext";

const DialerPopup = ({ isOpen, onClose, handleCall, user }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [callStatus, setCallStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentContact, setCurrentContact] = useState(null);
  const [showCallModal, setShowCallModal] = useState(false);
  const [callTime, setCallTime] = useState(0);
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [loadingState, setLoadingState] = useState({});

  // Call stats state
  const [callStats, setCallStats] = useState({
    callLimit: null,
    callsUsed: 0,
    remainingCalls: null,
    hasUnlimitedCalls: true
  });

  // Fetch call statistics
  const fetchCallStats = async () => {
    if (!user || !user.id) return;

    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_API}/api/users/call-stats/${user.id}`);
      setCallStats(response.data);
    } catch (error) {
      console.error('Error fetching call stats:', error);
    }
  };

  // Fetch call stats on mount
  React.useEffect(() => {
    fetchCallStats();
  }, [user]);
  // Function to add a digit

  const handlePhoneChange = (value, country) => {
    if (!value.startsWith("+")) {
      value = `+${value}`;
    }

    setPhoneNumber(value);
  };

  const { config } = useContext(ConfigContext);

  const handleBlur = () => {
    if (!phoneNumber.startsWith("")) {
      setPhoneNumber(`${phoneNumber.replace(/^\+?\d*/, "")}`);
    }
  };

  // Function to remove last digit
  const handleBackspace = () => {
    setPhoneNumber((prev) => prev.slice(0, -1));
  };

  // Reset state and close modal
  const handleClose = () => {
    setPhoneNumber(""); // Reset number
    onClose(); // Close modal
  };



  const startCall = async () => {
    // Check call limit before initiating call
    if (!callStats.hasUnlimitedCalls && callStats.remainingCalls <= 0) {
      toast.error('Call limit reached! You have no remaining calls.');
      return;
    }

    setCurrentContact(phoneNumber);
    setShowCallModal(true);
    setCallStatus('calling');
    setLoadingState(prev => ({ ...prev, [phoneNumber.id]: true }));

    try {
      const response = await axios.post(`${process.env.REACT_APP_SERVER_API}/api/create-call`, {
        to: phoneNumber,
        name: phoneNumber,
        first_message: config.firstMessage,
        prompt: config.callPrompt,
        userId: user.id || user._id,
        voiceId: config.voiceId,
        language: config.language,
        modelId: config.modelId,
        agentId: config.agentId
      }, {
        headers: { 'Content-Type': 'application/json' },
      });

      const { callId, callSid } = response.data;

      // Store the CallSid in localStorage for future use (e.g., ending the call)
      localStorage.setItem('currentCallSid', callSid);

      // Optionally, store the callId in localStorage if needed for database reference
      localStorage.setItem('currentCallId', callId);

      setCallStatus('connected');

      // Update call stats after successful call
      await fetchCallStats();

      // Show appropriate toast based on remaining calls
      const newRemaining = callStats.remainingCalls - 1;
      if (!callStats.hasUnlimitedCalls) {
        if (newRemaining === 0) {
          toast.warning('This was your last call! Contact admin to increase your limit.');
        } else if (newRemaining <= 5) {
          toast.warning(`Only ${newRemaining} calls remaining!`);
        } else {
          toast.success(`Call initiated successfully! Remaining calls: ${newRemaining}`);
        }
      } else {
        toast.success('Call initiated successfully!');
      }

      navigate(`/call/${encodeURIComponent(phoneNumber)}/${encodeURIComponent(phoneNumber)}`);

      // Navigate("/call")
      // Start call timer
      const startTime = Date.now();
      const timer = setInterval(() => {
        setCallTime(Math.floor((Date.now() - startTime) / 1000));
      }, 1000);
      // setCallStatus('completed');
      // Handle window close
      // navigate(`/dashboard`);
    } catch (error) {
      console.error('Call failed:', error);

      // Handle call limit error from backend
      if (error.response && error.response.status === 403) {
        toast.error(error.response.data.message || 'Call limit reached!');
        await fetchCallStats(); // Refresh stats
      } else {
        toast.error('Call failed. Please try again.');
      }

      setCallStatus('error');
    } finally {
      setLoadingState(prev => ({ ...prev, [phoneNumber.id]: false }));
    }
  };









  // Call API to end call

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      startCall(); // Call function when Enter is pressed
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[350px] text-center relative">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-700">Create Call</h2>

          <button className="text-gray-600 hover:text-red-500" onClick={handleClose}>
            <AiOutlineClose className="w-6 h-6" />
          </button>
        </div>

        {/* Display Entered Number */}
        {/* <div className="mb-3 text-2xl font-semibold border-b pb-2 h-10">
          {phoneNumber || "Enter Number"}
        </div> */}

        {/* <CustomPhoneInput onBlur={handleBlur} value={phoneNumber}  onChange={handlePhoneChange} ></CustomPhoneInput> */}

        <CustomPhoneInputd onKeyDown={handleKeyDown} onBlur={handleBlur} value={phoneNumber} onChange={handlePhoneChange}></CustomPhoneInputd>

        {/* Dialer Keypad */}
        <div className="grid grid-cols-3 gap-4 mb-4 mt-5">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, "*", 0, "#"].map((num) => (
            <button
              key={num}
              onClick={() => setPhoneNumber(phoneNumber + num)}
              className="w-16 h-16 text-2xl font-bold border rounded-full shadow-md bg-gray-100 hover:bg-gray-300 transition"
            >
              {num}
            </button>
          ))}
        </div>

        {/* Backspace, Call & End Call Buttons */}
        <div className="flex justify-center gap-4">
          {/* Backspace */}
          <button
            onClick={handleBackspace}
            className="bg-gray-500 text-white p-4 rounded-full shadow-lg hover:bg-gray-700 transition"
          >
            <FaBackspace className="w-6 h-6" />
          </button>

          {/* Call Button */}
          <button
            onClick={startCall}
            className="bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-700 transition"
          >
            <FaPhone className="w-6 h-6" />
          </button>
          <ToastContainer />
          {/* End Call Button */}
          {/* <button
            onClick={endCall}
            className="bg-red-500 text-white p-4 rounded-full shadow-lg hover:bg-red-700 transition"
          >
            <FaPhoneSlash className="w-6 h-6" />
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default DialerPopup;
